import { render, staticRenderFns } from "./appSet.vue?vue&type=template&id=f764c92c&scoped=true"
import script from "./appSet.vue?vue&type=script&lang=js"
export * from "./appSet.vue?vue&type=script&lang=js"
import style0 from "./appSet.vue?vue&type=style&index=0&id=f764c92c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f764c92c",
  null
  
)

export default component.exports